import React from 'react';
import { Tooltip } from '@nextiva/next-ui-components';

import { SvgQuestionMark } from 'components/SvgIcon';

export const Hint = ({ tool, tip }) => {
  return (
    <div>
      {tool}
      <Tooltip
        placement="top"
        title={<div className="Body m-chip-group__chips__tooltip">{tip}</div>}
        data-testid="PlatformAdminUI-UsersLink-Hint-ToolTip"
      >
        <div className="m-user-edit-drawer-section__licenses-help">
          <SvgQuestionMark />
        </div>
      </Tooltip>
    </div>
  );
};

export default Hint;
